import { useRef } from 'react';
import { useReducedMotion } from 'framer-motion';

/**
 * Tilt — effet de profondeur 3D au survol : la carte s'incline vers le curseur
 * (perspective + rotateX/Y). CSS pur, zéro dépendance, zéro three.js. Coupé sous
 * prefers-reduced-motion et inactif sur le tactile (mousemove ne s'y déclenche
 * pas). À utiliser comme wrapper autour d'une carte.
 *
 * @param {number} [props.max]  Inclinaison max en degrés (défaut 7).
 */
export default function Tilt({ children, max = 7, className = '' }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();

  if (reduce) return <div className={className}>{children}</div>;

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const rx = (0.5 - (e.clientY - r.top) / r.height) * max * 2;
    const ry = ((e.clientX - r.left) / r.width - 0.5) * max * 2;
    el.style.transform = `perspective(1000px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg)`;
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = '';
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`transition-transform duration-200 ease-out [transform-style:preserve-3d] will-change-transform ${className}`}
    >
      {children}
    </div>
  );
}
